__turbopack_context__.v({
  "blockLink": "VideoBlock-module-scss-module__xP9jqW__blockLink",
  "blocksBackgroundColor": "VideoBlock-module-scss-module__xP9jqW__blocksBackgroundColor",
  "blocksFontColor": "VideoBlock-module-scss-module__xP9jqW__blocksFontColor",
  "secondaryNavBackgroundColor": "VideoBlock-module-scss-module__xP9jqW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "VideoBlock-module-scss-module__xP9jqW__themeBackgroundColor",
  "themeFontColor": "VideoBlock-module-scss-module__xP9jqW__themeFontColor",
  "transitionEnter": "VideoBlock-module-scss-module__xP9jqW__transitionEnter",
  "transitionEnterActive": "VideoBlock-module-scss-module__xP9jqW__transitionEnterActive",
  "transitionEnterDone": "VideoBlock-module-scss-module__xP9jqW__transitionEnterDone",
  "transitionExit": "VideoBlock-module-scss-module__xP9jqW__transitionExit",
  "transitionExitActive": "VideoBlock-module-scss-module__xP9jqW__transitionExitActive",
  "transitionExitDone": "VideoBlock-module-scss-module__xP9jqW__transitionExitDone",
});
